export default {
      id: "picto-quote-bottom-usage",
      viewBox: "0 0 40 30",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#picto-quote-bottom-usage",
      toString: function () {
        return this.url;
      }
    }